import { Link } from 'react-router-dom';

// Footer component
type SignRightSideFooterProps = {
  linkDescription: string;
  link?: string;
  linkText: string;
  onClick?: () => void;
};

export const SignRightSideFooter = ({
  linkDescription,
  link,
  linkText,
  onClick,
}: SignRightSideFooterProps) => {
  return (
    <div className="text-center">
      <p className="text-sm text-muted-foreground">
        {linkDescription}
        {onClick ? (
          <button
            onClick={onClick}
            className="hover:text-primary/80 font-medium text-primary underline underline-offset-2 transition-colors cursor-pointer"
          >
            {linkText}
          </button>
        ) : link ? (
          <Link
            to={link}
            className="hover:text-primary/80 font-medium text-primary underline underline-offset-2 transition-colors"
          >
            {linkText}
          </Link>
        ) : null}
      </p>
    </div>
  );
};
